import { render, staticRenderFns } from "./SelectListProps.vue?vue&type=template&id=5ae28568&"
import script from "./SelectListProps.vue?vue&type=script&lang=js&"
export * from "./SelectListProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports